import * as tslib_1 from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import { Card, Checkbox, Button } from '@/components/UIComponents';
import swal from 'sweetalert2';
import { AuthenticationDAO } from "@/API/DAO/AuthenticationDAO";
let NewResetPassword = class NewResetPassword extends Vue {
    constructor() {
        super();
        this.newPassword = '';
        this.verifyPassword = '';
        this.newPassword = '';
        this.verifyPassword = '';
    }
    get confirmationCode() {
        return this.$route.query.confirmation.toString();
    }
    getError(fieldName) {
        return this.$validator.errors.first(fieldName);
    }
    get passwordValidation() {
        return {
            required: true,
            min: 4
        };
    }
    get verifyPasswordValidation() {
        return {
            required: true,
            confirmed: this.newPassword
        };
    }
    validate() {
        return this.$validator.validateAll().then(res => {
            return res;
        });
    }
    async updatePassword() {
        let valid = await this.validate();
        if (valid === true) {
            try {
                await AuthenticationDAO.resetPassword(this.confirmationCode, this.newPassword);
                await swal.fire({
                    title: `Password Reset`,
                    text: `Your password has been successfully reset. You will be redirected now to sign in...`,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-info btn-fill'
                });
                // @ts-ignore
                window.location = process.env.VUE_APP_CONFIGIO_URL + "/login?ReturnURL=%2FShoppingCart.aspx";
            }
            catch (error) {
                console.log('Failed to post update password request. ' + error);
                await swal.fire({
                    title: 'Password Reset Failed',
                    text: 'Your password reset request has failed. Please try again, if the problem continues please contact Aileron support',
                    type: 'error',
                    confirmButtonClass: 'btn btn-info btn-fill',
                    buttonsStyling: false
                });
            }
        }
    }
    mounted() {
    }
};
NewResetPassword = tslib_1.__decorate([
    Component({
        components: {
            [Card.name]: Card,
            [Checkbox.name]: Checkbox,
            [Button.name]: Button
        }
    })
], NewResetPassword);
export default NewResetPassword;
